import { Button, SimpleGrid } from "@mantine/core";
import {Icon, ICONS} from "vseth-canine-ui";
import protoFiles from "../providedFiles.json"


const OverviewList = (folder: any, level: number, path: string) => {
    const currentPath = path + "/" + folder.name;
    const marginStyle = {margin: '0.5em'} as React.CSSProperties;

    let currentElement = <></>
    const spacerArray = [];
    for (var i=0; i < level; i++){
        spacerArray.push(<Icon style={marginStyle} icon={ICONS.DOTS_V}/>);
    }
    if('items' in folder && folder.items.length > 0){
        if(folder.items.length === 1){
            currentElement = <>{spacerArray}<Button style={marginStyle} component="a" size="sm" radius="lg" href={currentPath + "/" + folder.name}>{folder.name}</Button><br/></>
        } else {
            const fileList = []
            for (var fileName of folder.items){
                fileList.push(<>{spacerArray}<Button style={marginStyle} component="a" size="sm" radius="lg" href={currentPath + "/" + fileName }>{fileName}</Button><br/></>)
            }
            currentElement = <>
                <h3>{spacerArray}{folder.name}</h3>
                {fileList}
            </>
        }
    } else {
        currentElement = <><h3>{spacerArray}{folder.name}</h3></>
    }
    const subFolderElements = [];
    for (let subFolder of folder.subFolders) {
        subFolderElements.push(OverviewList(subFolder, level+1, currentPath ));
    }
    return <div>
        {currentElement}
        {subFolderElements}
    </div>
}


export const Overview = () => {
    const overviewList = [];
    for (let folder of protoFiles.folders.subFolders) {
        overviewList.push(OverviewList(folder, 0, ""));
    }
    return (
        <SimpleGrid cols={5}>
            {overviewList[0]}
            {overviewList[1]}
            {overviewList[2]}
            {overviewList[3]}
            {overviewList[4]}
       </SimpleGrid>
    );
};
